import React, {forwardRef} from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const TBody = forwardRef(({children, className, asElement: Component = 'tbody', ...rest}, ref) => {
    const tBodyClass = classNames(Component !== 'tbody' && 'tbody', className)

    return (
        <Component className={tBodyClass} {...rest} ref={ref}>
            {children}
        </Component>
    )
})

TBody.propTypes = {
    asElement: PropTypes.string,
}

export default TBody
